import React from 'react';
import { TableCell } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const TableWhatMailSection = ({ mailingOption, title }) => {
  const { t } = useTranslation();

  return (
    <TableCell>
      {title}
      <div>
        <b>
          {mailingOption.managedBySystem
            ? t('mailNotifications.systemNotification')
            : ''}
        </b>
      </div>
    </TableCell>
  );
};

export default TableWhatMailSection;
